import { Component, OnInit, ViewChild, ViewEncapsulation  } from '@angular/core'
import { locale as en } from '../i18n/en'
import { locale as fr } from '../i18n/fr'
import { locale as de } from '../i18n/de'
import { locale as pt } from '../i18n/pt'
import { CoreTranslationService } from '@core/services/translation.service'
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { CoreConfigService } from '@core/services/config.service';
import { ColumnMode, DatatableComponent, id } from '@swimlane/ngx-datatable';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router'
import { ApiService } from 'app/main/services/Api/api.service'
import { HttpErrorResponse } from '@angular/common/http'
import { ToastService } from 'app/main/services/Toast/toast.service'
import { FormBuilder, FormGroup } from '@angular/forms'
import { ExcelService } from 'app/services/Excel/excel.service'

@Component({
  selector: 'app-events',
  templateUrl: './events.component.html',
  styleUrls: ['./events.component.scss']
})
export class EventsComponent implements OnInit {
  public contentHeader: object
  searchForm: FormGroup

  /**
   *
   * @param {CoreTranslationService} _coreTranslationService
   */
  constructor(private _coreTranslationService: CoreTranslationService,
    private modalService: NgbModal,private router: Router,
    private api: ApiService,public toastService: ToastService,
    private formBuilder: FormBuilder,private excelService: ExcelService) {
    this._coreTranslationService.translate(en, fr, de, pt)
    this.searchForm = this.formBuilder.group({
      StartDate: [''],
      EndDate: ['']
    })
  }

  // Lifecycle Hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */

  ngOnInit() {
    document.getElementById('الرئيسية')?.classList.remove('active')
    document.getElementById('المشرفين')?.classList.remove('active')
    document.getElementById('المستخدمين')?.classList.remove('active')
    document.getElementById('طلبات المشرفين')?.classList.remove('active')
    document.getElementById('فئات المناسبات')?.classList.remove('active')
    // document.getElementById('الإشعارات')?.classList.remove('active')
    document.getElementById('العروض')?.classList.remove('active')
    document.getElementById('المسئولين')?.classList.remove('active')
    this.columns = [
      {
        prop: 'selected',
        name: '',
        sortable: false,
        canAutoResize: false,
        draggable: false,
        resizable: false,
        headerCheckboxable: true,
        checkboxable: true,
        width: 50
      },
      { prop: '#' },
      { prop: 'nameAr', name: 'اسم الفعالية' },
      { prop: 'organizer', name: 'المشرف' },
      { prop: 'place', name: 'المكان' },
      { prop: 'startTime', name: 'التوقيتات' },
      { prop : 'saledTickets', name: 'التذاكر المباعة' },
      { prop : 'availableickets', name: 'التذاكر المتبقية' },
      { prop : 'totalSales', name: 'إجمالى المبيعات' },
      { prop : 'numberOfClientsPurchased', name: 'العملاء المسجلين' },
      { prop : 'numberOfScans', name: 'عدد عمليات المسح' },
      { prop : 'state', name: 'الحالة' },
      { prop : 'isActive', name: 'حالة المناسبة' },
      { prop : '', name: '' },
    ]
    this.loadEvents()
    this.temp = this.rows
    
    this.contentHeader = {
      headerTitle: 'الفعاليات',
      actionButton: false
    }
  }

  loadEvents(){
    this.api.showEventReports(1,100).subscribe({
      next: (response) => {
        const events = this.unpackEventRows(response)
        const now = new Date();
        this.rows = events.map( (item,index)=>{

          const startTime = new Date(item.startTime);
          const endTime = new Date(item.endTime);
          let state;
          if (now < startTime) {
            state = 'قادمة'; // Event is upcoming
          } else if (now > endTime) {
            state = 'منتهية'; // Event has ended
          } else {
            state = 'جارية'; // Event is ongoing
          }
                  console.log(state)

          return {
            "#": index + 1,
            id: item.id,
            nameAr: item.nameAr,
            organizer: item.organizer,
            place: item.place,
            startTime: item.startTime,
            saledTickets: item.saledTickets,
            numberOfClientsPurchased: item.numberOfClientsPurchased,
            availableickets: item.availableickets,
            numberOfScans: item.numberOfScans,
            state: state,
            isActive: item.isActive,
            totalSales:item.totalSales
          };
        })
        console.log(this.rows)
        this.temp = this.rows
      }, error: (error: HttpErrorResponse) => {
        this.rows = []
        this.temp = []
        this.toastService.show('حدث خطأ أثناء تحميل الفعاليات ❌');
      }
    })
  }

  private unpackEventRows(response: any): any[] {
    if (Array.isArray(response?.data)) {
      return response.data;
    }

    if (Array.isArray(response?.data?.data)) {
      return response.data.data;
    }

    if (Array.isArray(response)) {
      return response;
    }

    return [];
  }

  // table setup
  public readonly pageLimitOptions = [
    {value: 5},
    {value: 10},
    {value: 25},
    {value: 50},
    {value: 100},
  ];
  public chkBoxSelected = [];
  public currentVisible: number = 3;
  public currentPageLimit: number = 10;
  rows = [];
  temp = [];
  @ViewChild(DatatableComponent) public table: DatatableComponent;
  ColumnMode = ColumnMode;
  columns = []
  customChkboxOnSelect({ selected }) {
    this.chkBoxSelected.splice(0, this.chkBoxSelected.length);
    this.chkBoxSelected.push(...selected);
  }
  updateFilter(event: any) {
    const val = event?.target?.value ? event.target.value.toLowerCase() : '';
  
    // Filter data by checking all columns
    const temp = this.temp.filter((row) => {
      return Object.keys(row).some((key) => 
        row[key]?.toString().toLowerCase().includes(val)
      );
    });
  
    // Update the rows
    this.rows = temp;
    console.log(temp)
    // Reset to first page
    if (this.table) {
      this.table.offset = 0;
    }
  }
  public onLimitChange(limit: any): void {
    this.changePageLimit(limit);
    this.table.limit = this.currentPageLimit;
    this.table.recalculate();
    setTimeout(() => {
      if (this.table.bodyComponent.temp.length <= 0) {
        // TODO[Dmitry Teplov] find a better way.
        // TODO[Dmitry Teplov] test with server-side paging.
        this.table.offset = Math.floor((this.table.rowCount - 1) / this.table.limit);
        // this.table.offset = 0;
      }
    });
  }
  private changePageLimit(limit: any): void {
    this.currentPageLimit = parseInt(limit, 10);
  }
  public onVisibleChange(visible: any): void {
    this.currentVisible = parseInt(visible, 10);
  }
  modalOpenDefault(modalDefault) {
    this.modalService.open(modalDefault, {
      centered: true
    });
  }
  deletedItemId: any
  deleteItem(id: number) {
    console.log("Deleted Item ID:", id);
    this.deletedItemId = id; // Store ID for further actions
  }
  confirmDelete(){
    if(this.deletedItemId){
      this.api.deleteEvent(this.deletedItemId).subscribe({
        next: (response) => {
          if(response.success == true){
            console.log(response)
            this.toastService.show('تم الحذف بنجاح ✅');
            setTimeout(() => {
              window.location.reload()
            }, 2000);
          }
        }, error: (error: HttpErrorResponse) => {
          this.toastService.show('خطأ أثناء الحذف ❌');
        }
      });
    }
  }

  newEvent(){
    this.router.navigate(['/new-event']);
  }

  search(){
    console.log(this.searchForm.value)
  }

  // download files
  downloadFile(file: string){
    if(file == 'pdf'){
      let tableHTML = `
        <html>
          <head>
            <title>Table Export</title>
            <style>
              table { width: 100%; border-collapse: collapse; font-size: 14px; direction: rtl; }
              th, td { border: 1px solid black; padding: 8px; text-align: center; }
              th { background-color: #f2f2f2; }
            </style>
          </head>
          <body>
            <h2 style="text-align:center;">تقرير الفعاليات</h2>
            <table>
              <thead>
                <tr>
                  ${Object.keys(this.rows[0]).map(header => `<th>${header}</th>`).join("")}
                </tr>
              </thead>
              <tbody>
                ${this.rows.map(row => `
                  <tr>
                    ${Object.keys(row).map(key => `<td>${row[key].toString().replace(/<[^>]*>/g, '')}</td>`).join("")}
                  </tr>
                `).join("")}
              </tbody>
            </table>
          </body>
        </html>
      `;

      const newWindow = window.open("", "_blank");
      newWindow?.document.write(tableHTML);
      newWindow?.document.close();
      newWindow?.print();
    }else if(file == 'excel'){
      if (!this.rows || this.rows.length === 0) {
        alert("لا توجد بيانات للتصدير!");
        return;
      }
    
      let csvContent = "\uFEFF"; // UTF-8 BOM for Arabic compatibility
    
      // Extract column headers dynamically from the first row
      const headers = Object.keys(this.rows[0]); 
      csvContent += headers.join(",") + "\n";
    
      // Add Table Rows
      this.rows.forEach(row => {
        const rowData = headers.map(header => {
          let cell = row[header] ? row[header].toString() : '';
          return `"${cell.replace(/"/g, '""').replace(/<[^>]*>/g, '')}"`; // Escape quotes & remove HTML
        }).join(",");
        csvContent += rowData + "\n";
      });
    
      // Create a Download Link
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.setAttribute("download", "events.csv");
      document.body.appendChild(link);
    
      // Trigger Click
      link.click();
      document.body.removeChild(link);
    }
  }

  isActive: boolean
  eventIdToActiveOrDeactive: string
  blockOrActive(id: string,isActive: boolean){
    if(id){
      this.eventIdToActiveOrDeactive = id
      this.isActive = !isActive
    }
  }
  confirmBlockOrActive(){
    if(this.eventIdToActiveOrDeactive){
      this.api.updateEventStatus({eventId: this.eventIdToActiveOrDeactive,isActive: this.isActive}).subscribe({
        next: (response) => {
          if(response.success == true){
            console.log(response)
            this.toastService.show('تم التغيير بنجاح ✅');
            this.rows = this.rows.map((row: any) =>
              row.id === this.eventIdToActiveOrDeactive
                ? { ...row, isActive: this.isActive }
                : row
            );
            this.temp = this.temp.map((row: any) =>
              row.id === this.eventIdToActiveOrDeactive
                ? { ...row, isActive: this.isActive }
                : row
            );
            this.eventIdToActiveOrDeactive = '';
          }
        },error: (error: HttpErrorResponse) => {
          this.toastService.show('خطأ أثناء التغيير ❌');
        }
      })
    }
  }

  export(){
    const headers = {
      nameAr: 'اسم الفعالية',
      place: 'المكان',
      saledTickets: 'التذاكر المباعة',
      availableickets: 'التذاكر المتبقية',
      totalSales: 'إجمالى المبيعات',
      numberOfClientsPurchased: 'العملاء المسجلين',
      numberOfScans: 'عدد عمليات المسح',
      state: 'الحالة'
    };
    this.excelService.exportExcel('تقرير الفعاليات',this.rows,headers)
  }
}

